<template>
    <div class="sidebar-detail">
        <detail-header
            :title="(detailInfo.form||{}).name || '----'"
            @refreshDetailPage="refreshDetailPage"
            @closeDetailPage="closeDetailPage"
        />

        <el-tabs v-model="activeName" class="detail-tab" @tab-click="handleTabClick">
            <!-- DETAIL -->
            <el-tab-pane :label="$t('detail.Details')" name="tab_detail">
                <div v-if="detailInfo.subjectCustomRecordings && detailInfo.subjectCustomRecordings.length>0">
                    <div v-for="(subject, index) in detailInfo.subjectCustomRecordings" :key="'subject' + index">
                        <p class="detail-title">{{ ((subject.subject||{}).subjectType||{}).name || 'Subject' }}</p>
                        <table class="recording-detail-table">
                            <tr>
                                <td>{{ $t('detail.Id') }}</td>
                                <td>{{ (((subject||{}).subject||{}).id) || '-' }}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('detail.Name') }}</td>
                                <td>{{ (((subject||{}).subject||{}).name) || '-' }}</td>
                            </tr>
                            <tr>
                                <td>{{ $t('detail.QRCode') }}</td>
                                <td>{{ ((((subject||{}).subject||{}).qrCode||{}).code) || '-' }}</td>
                            </tr>
                            <extension-data-detail :extension-data="subject" extension-data-path="subject.extensionDataList" />
                            <!-- <tr>
                                <td>Origin Subject Type</td>
                                <td>
                                    <div v-if="subject.subjectParents.length > 0">
                                        <div class="parent-hierrachy-container" v-for="(parent, index) in subject.subjectParents" :key="'parent' + index">
                                            <p class="parent-hierrachy-text" @click="$_navigateTo({
                                                name: 'SubjectDetail',
                                                params: { 'subjectId': parent.subjectId } 
                                            })">{{parent.name}} </p>
                                            <span class="parent-hierrachy-text" v-if="index != subject.subjectParents.length - 1">&nbsp;> &nbsp;</span>
                                        </div>
                                    </div>
                                    <p v-else class="empty-text-table">------</p>
                                </td>
                            </tr> -->
                        </table>
                        <el-button v-if="subject.subject||{}.id" class="subject-detail-btn" size="mini" @click="$_navigateTo({ name: 'SubjectDetail', params: { 'subjectId': (subject.subject||{}).id }})">More</el-button>
                    </div>  
                </div>  
                
                <div v-if="detailInfo.subjectCustomRecordings">
                    <!-- <table class="recording-detail-table" >
                        <tr>
                            <td>Name</td>
                            <td>{{((detailInfo.subject||{}).name) || '-'}}</td>
                        </tr>
                        <tr>
                            <td>QR Code</td>
                            <td>{{(((detailInfo.subject||{}).qrCode||{}).code) || '-'}}</td>
                        </tr>
                        <extension-data-detail :extensionData="detailInfo" extensionDataPath="subject.extensionDataList"></extension-data-detail>
                        <tr>
                            <td>Origin Subject Type</td>
                            <td>
                                <div v-if="subjectParents.length > 0">
                                    <div class="parent-hierrachy-container" v-for="(parent, index) in subjectParents" :key="'parent' + index">
                                        <p class="parent-hierrachy-text" @click="$_navigateTo({
                                            name: 'SubjectDetail',
                                            params: { 'subjectId': parent.subjectId } 
                                        })">{{parent.name}} </p>
                                        <span class="parent-hierrachy-text" v-if="index != subjectParents.length - 1">&nbsp;> &nbsp;</span>
                                    </div>
                                </div>
                                <p v-else class="empty-text-table">------</p>
                            </td>
                        </tr>
                    </table> -->
                </div>
                <p v-else class="empty-text"> ------ </p>

                <p class="detail-title">{{ $t('detail.CollectedData') }}</p>
                <table class="recording-detail-table">
                    <tr>
                        <td>{{ $t('detail.Id') }}</td>
                        <td>{{ (detailInfo.id) || '-' }}</td>
                    </tr>
                    <tr v-if="(detailInfo.form||{}).breedingSubjectTypeName">
                        <td>{{ detailInfo.form.breedingSubjectTypeName }}</td>
                        <td>{{ getBreedingSubjectQRCode(detailInfo.form.breedingSubjectTypeName) }}</td>
                    </tr>
                    <tr v-if="(detailInfo.form||{}).breedingChildSubjectTypeName">
                        <td>{{ detailInfo.form.breedingChildSubjectTypeName }}</td>
                        <td>{{ getBreedingSubjectQRCode(detailInfo.form.breedingChildSubjectTypeName) }}</td>
                    </tr>
                    <extension-data-detail :extension-data="detailInfo" extension-data-path="extensionDataList" />
                </table>

                <!-- <p class="detail-title">{{ $t('detail.ShareRecord') }}</p>
                <table class="recording-detail-table">
                    <tr>
                        <td>{{ $t('detail.IsPublic') }}</td>
                        <td align="right">
                            <sharing-toggle 
                                share-item="RECORDING"
                                :record="detailInfo"
                                :form-id="detailInfo.formId"
                                :recording-id="detailInfo.id"
                                :is-public.sync="detailInfo.isPublic" 
                                :public-form-link="publicFormLink"
                                @handleIsPublicChange="handleIsPublicChange"
                                @updatePublicFormInfo="updatePublicFormInfo"
                                @createPublicCustomFields="createPublicCustomFields"
                            />
                        </td>
                    </tr>
                    <tr v-if="detailInfo.isPublic">
                        <td class="vertical-align">{{ $t('detail.PublicLink') }}</td>
                        <td class="vertical-align">
                            <copy-link :qr-img-name="qrImgName" :message="publicFormLink" />
                        </td>
                    </tr>
                    <tr v-if="detailInfo.publicEndTime">
                        <td>Expired At</td>
                        <td align="right"><span class="public-datetime"> {{ $_getDateTimeFormat(detailInfo.publicEndTime) }}</span></td>
                    </tr>
                </table> -->
                
                <div class="detail-title-container">
                    <p class="sidebar-title">{{ $t('detail.CollectedLocation') }}</p>
                    <expand-map :gps-location="formattedGPSLocation" />
                </div>
                <recording-map-2 :gps-location="formattedGPSLocation" />
                

                <p class="detail-title">{{ $t('detail.DateTime') }}</p>
                <div class="user-datetime-container">
                    <table>
                        <tr>
                            <td>{{ $t('detail.Recorded') }}</td>
                            <td>{{ $_getDateTimeFormat(detailInfo.recordingDate) }} {{ $t('detail.by') }} {{ (detailInfo.recordingUser||{}).userName || '-' }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('detail.Sync') }}</td>
                            <td>{{ $_getDateTimeFormat(detailInfo.syncTime) }} {{ $t('detail.by') }} {{ (detailInfo.syncUser||{}).userName || '-' }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('detail.Modified') }}</td>
                            <td>{{ $_getDateTimeFormat(detailInfo.lastModificationTime) }} {{ $t('detail.by') }} {{ (detailInfo.lastModifierUser||{}).userName || '-' }}</td>
                        </tr>
                        <tr>
                            <td>{{ $t('detail.Created') }}</td>
                            <td>{{ $_getDateTimeFormat(detailInfo.creationTime) }} {{ $t('detail.by') }} {{ (detailInfo.creatorUser||{}).userName || '-' }}</td>
                        </tr>
                    </table>
                </div>
            </el-tab-pane>

            <!-- HISTORY -->
            <el-tab-pane :label="$t('detail.History')" name="edit_history">
                <changes-history-table v-if="activeName=='edit_history'" :edit-history="editHistory" :edit-history-api-params="editHistoryApiParams" @handlePageChange="handleEditHistoryPageChange" />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import { compareValues } from "@/utils/sort-value";
import { customRecordingGet, customRecordingUpdate, customRecordingDelete, customRecordingExportData, customRecordingGetChangeHistory, customRecordingUpdatePublic, customRecordingCreatePublicCustomFields } from "@/api/custom_recording";
import ExtensionDataDetail from "@/components/ExtensionDataDetail";
import ChangesHistoryTable from "./changeHistoryTable";
import RecordingMap2 from "@/components/Dashboard/RecordingMap2";
import ExpandMap from "@/components/Dashboard/ExpandMap";
// import SharingToggle from "./SharingToggle";
// import copyLink from "./copyLink";
import DetailHeader from "./DetailHeader";

export default {
    components: {
        "extension-data-detail": ExtensionDataDetail,
        "changes-history-table": ChangesHistoryTable,
        "recording-map-2": RecordingMap2,
        "expand-map": ExpandMap,
        // "sharing-toggle": SharingToggle,
        // "copy-link": copyLink,
        "detail-header": DetailHeader
    },
    props: {
        infoSidebarId: {
            type: Number | String
        }
    },
    data() {
        return {
            activeName: "tab_detail",
            historyRecord: null,
            detailInfo: {},
            publicCode: null,
                
            editHistory: null,
            editHistoryCurrentPage: 1,
            editHistorySkipCount: 0,
            editHistoryMaxResultCount: 5,
        };
    },
    computed: {
        editHistoryApiParams() {
            var fix_params = {
                "SkipCount": this.editHistorySkipCount,
                "MaxResultCount": this.editHistoryMaxResultCount,
            };
            var params = Object.assign(fix_params);
            return params;
        },
        formattedGPSLocation() {
            if (this.detailInfo && this.detailInfo.gpsLocation) {
                var gps = {
                    latitude: (this.detailInfo.gpsLocation || {}).latitude,
                    longitude: (this.detailInfo.gpsLocation || {}).longitude
                };
                return gps;
            }
            else return null;
        },
        subjectExtensionData() {
            return (this.detailInfo.subject || {}).extensionDataList || [];
        },
        recordingExtensionData() {
            return this.detailInfo.extensionDataList || [];
        },
        subjectParents() {
            var arry = ((this.detailInfo || {}).subject || {}).parents;
            var nextParent;
            var nextSequence = 1;

            var allChildId = arry.map(arr => arr.childId);
            arry.forEach(i => {
                if (!allChildId.includes(i.subjectId)) {
                    i.sequence = nextSequence++;
                    nextParent = i;
                }
            });

            arry.forEach(i => {
                arry.forEach(j => {
                    if (j.subjectId == nextParent.childId) {
                        j.sequence = nextSequence++;
                        nextParent = j;
                    }
                });
            });

            return arry.sort(compareValues("sequence", "asc"));
        },
        publicFormLink() {
            return `${window.location.protocol}//${window.location.host}/darwin-sharing-record/${this.detailInfo.publicCode}`;
        },
        qrImgName() {
            if (this.detailInfo) return "recording_" + this.detailInfo.id;
            else return "";
        }
    },
    watch: {
        infoSidebarId: {
            immediate: true,
            handler(newVal, oldVal) {
                this.getDetails();
            },
        }
    },
    methods: {
        getBreedingSubjectQRCode(breedingSubjectName) {
            return this.detailInfo[this.getBreedingSubjectName(breedingSubjectName)]?.qrCode?.code || "-";
        },
        getBreedingSubjectName(breedingSubjectName) {
            let name = breedingSubjectName.charAt(0).toLowerCase() + breedingSubjectName.slice(1);
            return name;
        },
        async getDetails() {
            var res = await customRecordingGet({ Id: this.infoSidebarId });
            if (res) {
                this.detailInfo = res;
            }

            if (this.activeName == "edit_history") this.getEditHistory();
        },
        closeDetailPage() {
            this.$store.dispatch("info_sidebar/setInfoSidebar");
            this.$store.dispatch("info_sidebar/setInfoSidebarObject", "");
        },
        refreshDetailPage() {
            this.getDetails();
        },
        handleEditHistoryPageChange(event) {
            this.editHistorySkipCount = event;
            this.getEditHistory();
        },
        async getEditHistory() {
            var res = await customRecordingGetChangeHistory({ "CustomRecordingId": this.detailInfo.id, "Sorting": "creationTime desc", ...this.editHistoryApiParams });
            this.editHistory = res;
        },
        handleTabClick(tab, event) {
            if (tab.name == "edit_history") {
                this.getEditHistory();
            }
        },
        async handleIsPublicChange(event) {
            let res = await customRecordingUpdatePublic(this.detailInfo);
            if (res) {
                this.detailInfo.publicCode = res.publicCode;
            }
        },
        async updatePublicFormInfo(event) {
            let res = await customRecordingUpdatePublic({
                "id": this.detailInfo.id,
                "isPublic": true,
                ...event
            });
        },
        async createPublicCustomFields(event) {
            if (event) {
                let res = await customRecordingCreatePublicCustomFields(event);
            }
        }
    }
};
</script>

<style lang="css" scoped>
.sidebar-detail p{
    margin: var(--space-8) 0;
}
.sidebar-detail ul li{
    margin: var(--space-12) 0;
    font-size: var(--form-label-size);
}
.recording-detail-table tr td{
    margin: var(--space-12) 0;
    font-size: var(--form-label-size);
    padding: var(--space-4) var(--space-8);
    color: var(--charcoal-black)
}
.detail-title {
    font-weight: 700;
    line-height: 30px;
    border-bottom: 1px solid var(--border-line);
    color: var(--main-color-1)
}
.detail-header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.page-title {
    color: var(--main-color-1);
    font-size: var(--detail-page-title);
}
.empty-text-table{
    color: var(--charcoal-black);
}
.subject-detail-btn{
    margin: var(--space-4) var(--space-8);
}
.sidebar-group-btn{
    display: flex;
}
.detail-tab .el-tabs__header{
    margin: 0
}
</style>


// WEBPACK FOOTER //
// src/components/SidebarDetail/FormRecordingSidebarDetail.vue